import FreePostComments from "./FreePostComments";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import BoardDetail from "../../../component/board/BoardDetail";
import { useAuth } from "../../../global/AuthContext";
import { boardError, freeBoardApi, FreePost } from "./api";

export default function ViewFreePost() {
    const { id = "" } = useParams();
    const [params] = useSearchParams();
    const listUrl = `/freeboard?page=${Number(params.get("page")) || 1}`;
    const navigate = useNavigate();
    const { user } = useAuth();
    const [post, setPost] = useState<FreePost | null>(null);
    const [error, setError] = useState("");
    const [deleting, setDeleting] = useState(false);
    useEffect(() => {
        const controller = new AbortController();
        setPost(null); setError("");
        freeBoardApi.read(id, false, controller.signal).then(res => { if (!controller.signal.aborted) setPost(res.data); })
            .catch(err => { if (!controller.signal.aborted) setError(boardError(err)); });
        return () => controller.abort();
    }, [id]);
    const remove = async () => {
        if (!window.confirm("게시글을 삭제하시겠습니까?")) return;
        setDeleting(true);
        try { await freeBoardApi.remove(id); navigate(listUrl, { replace: true }); }
        catch (err) { setError(boardError(err)); setDeleting(false); }
    };
    if (!post) return <div className="BoardDetail"><p role={error ? "alert" : "status"}>{error || "불러오는 중..."}</p><Link to={listUrl}>목록</Link></div>;
    const canEdit = user && (user.id === post.authorId || user.role.toLowerCase() === "admin");
    return <><BoardDetail post={post} actions={<>
        <button onClick={() => navigate(listUrl)}>목록</button>
        {canEdit && <><button disabled={deleting} onClick={() => navigate(`/freeboard/update/${id}`)}>수정</button><button disabled={deleting} onClick={remove}>{deleting ? "삭제 중..." : "삭제"}</button></>}
    </>}/><FreePostComments key={id} postId={id}/>{error && <p className="BoardDetail" role="alert">{error}</p>}</>;
}
